import { Block } from 'components/Block'
import {
  SecurityHeroContent,
  SecurityHeroContentBox,
  SecurityHeroContentWrapper,
  SecurityHeroImage,
} from './SecurityHero.styled'
import { Spacer } from 'components/spacer/Spacer'
import { Text, Title, Title_h1_default } from 'components/Typography'
import { useTranslation } from 'next-i18next'

export function SecurityHero() {
  const { t } = useTranslation('security')
  return (
    <Block>
      <SecurityHeroContentWrapper>
        <SecurityHeroImage
          src="/images/securityHero.jpg"
          srcSet="/images/securityHero.jpg 1x, /images/securityHero@2x.jpg 2x"
          alt="GoodTrust"
        />
        <SecurityHeroContent>
          <SecurityHeroContentBox>
            <Title variant={Title_h1_default} css={{ maxWidth: '29rem' }}>
              {t('security.hero_title')}
            </Title>

            <Spacer size={[1, 1.825]} />

            <Text css={{ marginBottom: '1.75rem' }}>{t('security.hero_desc')}</Text>
          </SecurityHeroContentBox>
        </SecurityHeroContent>
      </SecurityHeroContentWrapper>
    </Block>
  )
}
